// REDUX
import { createSlice } from "@reduxjs/toolkit";
import { getAllLockers, getLocker, getLockerSlots } from "api/lockerApi";

// MISC
import { ILockerInitialState } from "models/interfaces";

const initialState: ILockerInitialState = {
  lockersList: [],
  isLoading: false,
  errorMessage: "",
};

export const lockerSlice = createSlice({
  name: "session",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllLockers.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllLockers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.lockersList = action.payload;
    });
    builder.addCase(getAllLockers.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
    builder.addCase(getLocker.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getLocker.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getLocker.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
    builder.addCase(getLockerSlots.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getLockerSlots.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getLockerSlots.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {} = lockerSlice.actions;

export const lockersList = (state) => state.locker.lockersList;

export default lockerSlice.reducer;
